import { FETCH_ORGANIZATION, FETCH_ORGANIZATION_SUCCESS, FETCH_ORGANIZATION_FAILER } from './OrganisationActionTypes'

export const fetchOrganizationRequest = () => {
    return {
        type: FETCH_ORGANIZATION
    }
}

export const fetchOrganizationSuccess = (data: any) => {
    return {
        type: FETCH_ORGANIZATION_SUCCESS,
        payload: data
    }
}


export const fetchOrganizationFailer = (errorMsg: any) => {
    return {
        type: FETCH_ORGANIZATION_FAILER,
        payload: errorMsg
    }
}


